import Cookies from 'js-cookie'

const clearToken = (router) => {
  Cookies.remove('pc_token')
  setTimeout(() => {
    router.push({
      name: 'login'
    })
  }, 1000)
}

export default (Vue, router, config) => {
  return new Map([
    ['Error0000', () => {
      Vue.prototype.$fail('系统错误')
    }],
    ['Error1000', () => {
      Vue.prototype.$fail('登陆失效')
      clearToken(router)
    }],
    ['Error1003', () => {
      Vue.prototype.$fail('登录失败');
      clearToken(router)
    }],
    ['Error1001', () => {
      Vue.prototype.$fail(config.data.msg)
      clearToken(router)
    }],
    ['Error1002', () => {
      Vue.prototype.$fail(config.data.msg)
      clearToken(router)
    }],
    ['Error7051', () => {
      Vue.prototype.$fail('短信验证码有误，请检查')
    }],
    ['Error80004', () => {
      Vue.prototype.$fail('更新或创建失败')
    }],
    ['Error80001', () => {
      Vue.prototype.$fail('简历状态修改错误')
    }],
    ['Error80002', () => {
      Vue.prototype.$fail('面试时间没有填写')
    }],
    ['Error80003', () => {
      Vue.prototype.$fail('简历状态为面试时才能修改此状态')
    }],
    ['Error0004', () => {
      Vue.prototype.$fail('没有权限')
    }],
    ['Error5005003', () => {
      Vue.prototype.$fail('企业认证已经在审核中或已通过')
    }],
    ['Error5005002', () => {
      Vue.prototype.$fail('企业认证操作失败')
    }],
    ['Error5006002', () => {
      Vue.prototype.$fail('今日剩余邀请次数已用完，明天再来吧~')
    }],
    ['Error5006001', () => {
      Vue.prototype.$fail('已经邀请过了')
    }],
    ['Error5008001', () => {
      Vue.prototype.$fail('企业简称仅可编辑一次')
    }],
    ['Error5008002', () => {
      Vue.prototype.$fail('简称与其他企业冲突，请更换')
    }],
    ['Error5008003', () => {
      Vue.prototype.$fail('该手机号已注册过平台招聘者，TA可直接登录使用')
    }],
    ['Error5100001', () => {
      Vue.prototype.$fail('该手机号已注册，可直接登录')
    }],
    ['Error5100002', () => {
      Vue.prototype.$fail('该手机号不存在')
    }],
    ['Error5100003', () => {
      Vue.prototype.$fail('手机号或密码错误')
    }],
    ['Error5100004', () => {
      Vue.prototype.$fail('该账号已禁用，如需申述，请关注“地产同行圈”公众号并联系客服')
    }],
    ['Error5100005', () => {
      Vue.prototype.$fail('该手机号已注册，请更换其他手机号注册或直接登录')
    }],
    ['Error5100006', () => {
      Vue.prototype.$fail('该手机号未注册')
    }],
    ['Error5100007', () => {
      Vue.prototype.$fail('旧密码错误，若忘记密码，可先退出登录再找回')
    }],
    ['Error5201001', () => {
      Vue.prototype.$fail('贵企业已经享受过该活动啦，无法重复领取，如需继续获得招聘权益，可以购买套餐哦~')
    }],
    ['Error5201002', () => {
      Vue.prototype.$fail('未拥有套餐的用户才能领取新入驻套餐')
    }],
    ['Error5200003', () => {
      Vue.prototype.$fail('该职位正在置顶中，请等待置顶结束后再添加')
    }],
    ['Error5200004', () => {
      Vue.prototype.$fail('职位置顶定价变更, 请稍后重试')
    }],
    ['Error5200005', () => {
      Vue.prototype.$fail('职位置顶点余量不足')
    }],
    ['Error5200006', () => {
      Vue.prototype.$fail('职位可刷新时间未到')
    }],
    ['Error5200007', () => {
      // Vue.prototype.$fail('企业在所选城市下，剩余可用职位数量不足，如需继续发布，可购买「职位发布数」')
    }],
    ['Error5009001', () => {
      Vue.prototype.$fail('简历钥匙已过期')
    }],
    ['Error5009002', () => {
      Vue.prototype.$fail('简历钥匙无效')
    }],
    ['Error5202001', () => {
      Vue.prototype.$fail('今日剩余邀投次数已用完，先收藏明天再来吧')
    }],
    ['Error5202002', () => {
      Vue.prototype.$fail('简历下载余量不足')
    }],
    ['Error5201003', () => {
      Vue.prototype.$fail('该权益已暂停领取')
    }],
    ['Error5201004', () => {
      Vue.prototype.$fail('企业已经领取过该权益啦~')
    }],
    ['Error5101001', () => {
    
    }],
    ['Error5201005', () => {
      Vue.prototype.$fail('该权益限平台招聘PLUS会员免费领取，如需开通可联系服务顾问购买招聘套餐')
    }],
    ['Error5200008', () => {
    }],
    ['Error5200009', () => {
    }],
    ['Error5200010', () => {
    }],
    ['Error5200011', () => {
      Vue.prototype.$fail('职位刷新点余量不足')
    }],
    ['Error5200012', () => {
      Vue.prototype.$fail('7日后可再推该职位')
    }],
    ['Error5200013', () => {
      Vue.prototype.$fail('职位省心推定价变更, 请稍后重试')
    }],
    ['Error5200014', () => {
      Vue.prototype.$fail('职位省心推余量不足')
    }],
    ['default', () => {
      Vue.prototype.$fail(config.data.msg)
    }]
  ])
}
